import { DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../../contexts/LanguageContext";
import { cardClass } from "../../components/ui/styles";
import { Pill } from "../../components/ui/Pill";

// What each role may do, as the API enforces it (authorize_admin on every
// edit/delete endpoint, authorize_owner on store deletion, and the scanner-only
// allowlist of customer index/show/scan). Keep this in step with those rules.
export default function RolesGuide() {
  const { t } = useLanguage();
  const roles = [
    { label: t("roles.owner"), tone: "dark", text: t("team.roles.owner") },
    { label: t("roles.admin"), tone: "indigo", text: t("team.roles.admin") },
    { label: t("roles.member"), tone: "neutral", text: t("team.roles.member") },
    {
      label: t("team.scannerOnly.badge"),
      tone: "orange",
      text: t("team.roles.scannerOnly"),
    },
  ];

  return (
    <section aria-labelledby="team-roles-title" className="flex flex-col gap-3">
      <h2
        id="team-roles-title"
        className="text-base font-semibold text-gray-900"
      >
        {t("team.roles.title")}
      </h2>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-3">
        {roles.map((role) => (
          <div
            key={role.label}
            className={`${cardClass} flex flex-col gap-1.5 rounded-xl px-4 py-3.5`}
          >
            <Pill tone={role.tone} className="min-w-[72px] self-start">
              {role.label}
            </Pill>
            <p className="text-[13px] leading-normal text-gray-600">
              {role.text}
            </p>
          </div>
        ))}
        <a
          href="https://download.loyaltify.io"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-3 rounded-xl bg-gray-900 px-4 py-3.5 text-white hover:bg-gray-800"
        >
          <span
            aria-hidden="true"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-gray-700"
          >
            <DevicePhoneMobileIcon className="h-5 w-5" />
          </span>
          <span className="flex flex-col gap-0.5">
            <span className="text-sm font-semibold">
              {t("team.scannerApp.title")}
            </span>
            <span className="text-xs text-gray-300">
              {t("team.scannerApp.platforms")}
            </span>
          </span>
        </a>
      </div>
    </section>
  );
}
